// extracted by mini-css-extract-plugin
export default {"panel":"IslandPanel_panel__oQbwV"};